import ActionsStore from "./ActionsStore";
import ObjectsStore from "./ObjectsStore";
import Show from "./Show";
import Route from "./Route";

const Objects = ObjectsStore;
const Actions = ActionsStore;

export { Route, Show, Objects, Actions };